import { Box, Card, CardContent, Chip, Grid, List, ListItem, Typography } from "@mui/material";
import { ReactNode } from "react";
import { Option } from 'src/features/autocomplete/types'
import FilterDialog from "./FilterDialog";
import { Filter, FilterCategory, OptionWithSelect } from "./FilterTypes";
import DoneIcon from '@mui/icons-material/Done';
import BlockIcon from '@mui/icons-material/Block';

type Props = {
    filter: Filter,
    cat: FilterCategory,
    activeOptionValue: string,
    searchValue: string,
    toggleOption: (selectedCat: FilterCategory, selectedOpt: Option) => void
}

const FilterSelectComponent = ({ cat, activeOptionValue, filter, toggleOption, searchValue }: Props) => {
    const getOptionIcon = (opt: OptionWithSelect, cat: FilterCategory): ReactNode => {
        const selectedOption = filter.options.find(op => op.value === opt.value && op.optionType === cat.optionType);

        if (selectedOption) {
            return selectedOption.inclusive ? <DoneIcon sx={{ color: 'green', sx: { mr: 2.5 } }} /> : <BlockIcon sx={{ color: 'red', sx: { mr: 2.5 } }} />
        }

        return <DoneIcon sx={{ color: 'green', opacity: 0, sx: { mr: 2.5 } }} />;
    }

    return (
        <Grid item xs={12} sm={6} key={cat.optionType}>
            <Typography component='p' variant='overline' sx={{ lineHeight: 1.25, color: 'text.disabled', pb: 2 }}>
                {cat.category}
            </Typography>

            <List sx={{ py: 0.5 }}>
                {cat.filteredOptions.map((opt) => {
                    let border = 'none';

                    if (opt.value === activeOptionValue) {
                        //border = '1px solid red'
                    }

                    return <ListItem key={opt.value} sx={{ py: 0.5, border: border }} disablePadding onClick={() => toggleOption(cat, opt)}>
                        <Box
                            component='a'
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                textDecoration: 'none',
                                '&:hover > *': { color: 'primary.main' }
                            }}
                        >
                            {getOptionIcon(opt, cat)}
                            <Typography variant='body2' sx={{ color: 'text.primary' }}>
                                {opt.name}
                            </Typography>
                        </Box>
                    </ListItem>
                })}
                {cat.hasMore && <ListItem key={`more-${cat.optionType}`} sx={{ py: 0.5 }} disablePadding>
                    <FilterDialog category={cat} toggleOption={toggleOption} defaultSearchValue={searchValue} filter={filter}>
                        <Typography variant='body2' sx={{ color: 'text.primary' }}>
                            More...
                        </Typography>
                    </FilterDialog>
                </ListItem>}
            </List>
        </Grid>
    )
}

export default FilterSelectComponent;